export default function Info({ fieldSpec }: any) {
  if (!fieldSpec.properties.TEXT) return null;

  return <div dangerouslySetInnerHTML={{ __html: fieldSpec.properties.TEXT }} data-testid="container-inner" />;
}
